/**
 * @param roiCalculatorDocument {Document}
 */
module.exports = function triggerRoiCalculatorOutputFailedEvent(roiCalculatorDocument) {
    const event = new CustomEvent("outputFailed");
    roiCalculatorDocument.dispatchEvent(event);
}